import { Routes } from '@angular/router';

import { RoleGuard } from '../../core/auth/role-guard';

export const documentsRoutes: Routes = [
  {
    path: 'documents',
    title: 'Documents',
    data: {
      roles: ['SuperAdmin', 'Quality.Admin'],
    },
    canActivate: [RoleGuard],
    children: [
      {
        path: 'settings',
        title: 'Settings',
        loadComponent: () => import('./pages/document-settings-list/document-settings-list.component').then(module => module.DocumentSettingsListComponent),
      },
      {
        path: 'settings/:id',
        title: 'Setting',
        loadComponent: () => import('./pages/document-settings-form/document-settings-form.component').then(module => module.DocumentSettingsFormComponent),
      },
    ],
  },
];
